import React from "react";
import DropdownCustom from "../../../../../components/DropdownCustom";
import { useDispatch, useSelector } from "react-redux";
import { globalSettingSelector } from "../../../../App/selectors/AppSelectors";
import {
  filterMarketOptionsSelector,
  filterMarketSelector,
  propertyFilterSelector,
} from "../../../selectors/BookSelectors";
import {
  filterMarketAction,
  listDayOfficeFilterAction,
  listMeetingRoomFilterAction,
  propertyFilterAction,
} from "../../../actions/BookActions";
import {
  FILTER_END_TIME_KEY,
  FILTER_MARKET_SESSION,
  FILTER_START_TIME_KEY,
} from "../../../configs/Constants";
import { convertDate2StatEndTimeUsingMoment } from "../../../services/Common";
import moment from "moment-timezone";
import "./styles.scss";

const Market = () => {
  const dispatch = useDispatch();
  const globalSetting = useSelector(globalSettingSelector);
  const filterMarket = useSelector(filterMarketSelector);
  const filterMarketOptions = useSelector(filterMarketOptionsSelector);
  const propertyFilter = useSelector(propertyFilterSelector);

  return (
    <DropdownCustom
      className={"dropdown-select-market"}
      options={filterMarketOptions}
      value={filterMarket?.city_code}
      onChange={(event, { value }) => {
        if (typeof value !== "string" || value === filterMarket?.city_code) {
          return;
        }

        const marketChoose = globalSetting?.location.find(
          ({ city_code }: { city_code: string }) => city_code === value
        );
        dispatch(filterMarketAction(marketChoose));
        sessionStorage.setItem(FILTER_MARKET_SESSION, marketChoose.city_code);

        const locationReset = { lat: null, lng: null, searchByLandmark: false };
        dispatch(listMeetingRoomFilterAction(locationReset));
        dispatch(listDayOfficeFilterAction(locationReset));

        const savedDate = sessionStorage.getItem("DEFAULT_DATE");
        let startTime = null;
        let endTime = null;
        if (savedDate) {
          const time = convertDate2StatEndTimeUsingMoment(
            marketChoose.timezone,
            moment(savedDate)
          );
          startTime = time.startTime;
          endTime = time.endTime;
        }

        dispatch(
          propertyFilterAction({
            ...propertyFilter,
            ...locationReset,
            city_code: marketChoose.city_code,
            page: 1,
            [FILTER_START_TIME_KEY]: startTime,
            [FILTER_END_TIME_KEY]: endTime,
          })
        );
        sessionStorage.removeItem("DEFAULT_ROOM_LOCATION");
        sessionStorage.removeItem("DEFAULT_DAY_OFFICE_LOCATION");
        sessionStorage.removeItem("DEFAULT_LOCATION");
      }}
    />
  );
};

export default Market;
